import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { SessionProvider } from '../../providers/SessionProvider';
import { ServiceProvider } from '../../providers/ServiceProvider';

/*
  Generated class for the Login page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'page-Login',
    templateUrl: 'Login.html'
})
export class LoginPage {
    a_uName: string = '';
    a_password: string = '';
    rememberMe: boolean = false;
    constructor(public navCtrl: NavController, public navParams: NavParams, public serviceProvider: ServiceProvider, public sessionProvider: SessionProvider, public toastController: ToastController) { }

    ionViewDidLoad() {
        let up: any = this.sessionProvider.getUp();
        if (up != null) {
            this.a_uName = up.username;
            this.a_password = up.password;
        }
        this.sessionProvider.clear();
    }
    login() {
        console.log(this.rememberMe);
        var randomNumber = this.sessionProvider.getUniqId();
        this.serviceProvider.Get("Client/Login?username=" + this.a_uName + "&pwd=" + this.a_password + "&uniquecode=" + randomNumber, false).then((result) => {
            console.log(result[0]);
            if (result[0].a_Response == 0) {
                let loginData = {
                    Token: result[0].Token,
                    Name: result[0].clName,
                    Username: this.a_uName,
                    RoleName: result[0].rName,
                    tRoleId: result[0].tRoleId,
                    tOwnerId: result[0].tOwnerId,
                    Id: result[0].tClientId,
                    ExpDate: result[0].ExpDate,
                };
                this.sessionProvider.setMember(loginData);
                if (this.rememberMe) {
                    this.sessionProvider.SetUp(this.a_uName, this.a_password);
                }
                this.navCtrl.pop();
            }
            else {
                const toast = this.toastController.create({
                    message: result[0].a_Message,
                    duration: 2000
                });
                toast.present();
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/Login/Login.ts